import { Button } from '@ps-design-system/components/Button';
import get from 'lodash/get';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { change, Field } from 'redux-form';
import { CATERING_PACKAGE_FORM } from '../../../app-main/components/reduxForms/constants/formNames';
import RadioField from '../../../app-main/components/reduxForms/fields/RadioField/RadioField';

export const CateringAddOnRadioField = ({ addOn, dispatch, formValues }) => {
  return (
    <div className="catering-addons-radio-wrap">
      <Field
        name={`addOns.${addOn.id}`}
        component={RadioField}
        options={addOn.options.map((option) => ({
          id: option.name,
          value: option.name,
          label: (
            <span>
              {option.name}
              {option.price?.value > 0 && (
                <span className="text-gray-600">
                  {' '}
                  (
                  <FormattedNumber
                    value={option.price.value}
                    currency="USD"
                    style="currency"
                    minimumFractionDigits={
                      Number.isInteger(option.price.value) ? 0 : 2
                    }
                    maximumFractionDigits={2}
                  />
                  {option.price?.per_person && ' per person'})
                </span>
              )}
            </span>
          )
        }))}
      />
      <Button
        variant="text-only"
        className="margin-md-top tw-body-1"
        disabled={!get(formValues, `addOns.${addOn.id}`)}
        onClick={() =>
          dispatch(change(CATERING_PACKAGE_FORM, `addOns.${addOn.id}`, null))
        }
      >
        Clear
      </Button>
    </div>
  );
};
